import styled from 'styled-components'
import { t } from 'ttag'

import { Text } from '@h2/components/typography/text'
import { InfoCircleIcon } from '@h2/components/icons/infoCircle'
import { Link } from '@h2/common/components/link'

const Wrap = styled.div`
  display: flex;
  grid-area: inf;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;

  > div {
    display: flex;
    align-items: center;
    gap: 5px;
    min-width: fit-content;
  }

  > a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 180px;
  }
`
const Info = () => (
  <Wrap>
    <div>
      <InfoCircleIcon size="tiny" />
      <Link
        ssr={true}
        target="_blank"
        href="https://help.headed2.com/a/solutions/articles/70000628242?lang=en">
        <Text size="small">{t`Want to know more about the CareerHub?`}</Text>
      </Link>
    </div>
    <Link
      size="medium"
      href="/careerhub"
      variant="button"
      weight="bold"
      margin="0 0 0 auto">
      {t`Open your CareerHub`}
    </Link>
  </Wrap>
)

export { Info }
